import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import PublicPatientScheduling from '../../components/availabilities/PublicPatientScheduling';
import { 
  setDate, 
  setTime, 
  setSessionTypeId, 
  setProviderAvailabilityId,
  setLocationType,
  reset,
} from '../../redux/reducers/newAppointmentForm';

const PublicBookingPage = (props) => {
  useEffect(() => {
    props.reset();
  }, []);
  return (
    <PublicPatientScheduling
      {...props}
    />
  );
};

const mapState = state => ({
});

const mapDispatch = dispatch => ({
  saveDate: dateStr => dispatch(setDate(dateStr)),
  saveTime: timeStr => dispatch(setTime(timeStr)),
  saveSessionTypeId: sessionTypeId => dispatch(setSessionTypeId(sessionTypeId)),
  saveProviderAvailabilityId: providerAvailabilityId => 
    dispatch(setProviderAvailabilityId(providerAvailabilityId)),
  saveLocationType: locationType => dispatch(setLocationType(locationType)),
  reset: () => dispatch(reset()),
});

export default connect(mapState, mapDispatch)(PublicBookingPage);